import { Box, Indicator, Tooltip, UnstyledButton } from '@mantine/core'
import { IconUserPlus } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

// HIG alignment with the top bar cluster: 36px visible circle (same diameter
// as the user avatar) inside a 44px touch target, subtle hover, no border.
const TOUCH_TARGET = 44
const CIRCLE_SIZE = 36
const ICON_SIZE = 20

interface Props {
  count: number
  onClick: () => void
}

export function PendingRequestsBadge({ count, onClick }: Props) {
  const { t } = useTranslation()
  const hasRequests = count > 0

  return (
    <Tooltip label={t('student_requests.title')} position='bottom' withArrow>
      <UnstyledButton
        onClick={onClick}
        aria-label={t('student_requests.title')}
        sx={{
          width: TOUCH_TARGET,
          height: TOUCH_TARGET,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
        }}
      >
        <Indicator
          label={hasRequests ? count : undefined}
          size={16}
          color='red'
          offset={4}
          position='top-end'
          disabled={!hasRequests}
        >
          <Box
            sx={theme => ({
              width: CIRCLE_SIZE,
              height: CIRCLE_SIZE,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: theme.colorScheme === 'dark' ? theme.colors.dark[0] : theme.colors.dark[8],
              backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[1],
              transition: 'background-color 150ms ease',
              '&:hover': {
                backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2],
              },
            })}
          >
            <IconUserPlus size={ICON_SIZE} />
          </Box>
        </Indicator>
      </UnstyledButton>
    </Tooltip>
  )
}
